import React from 'react';
import { CHAT_ROLES } from '../../data/chatRoles';
import './LarpBar.css';

const LarpBar = ({ role, onSelect }) => {
  return (
    <div id="larp-options" className="larp-bar" role="group" aria-label="Role-play scenes">
      {CHAT_ROLES.map((scene) => (
        <button
          key={scene.id}
          type="button"
          className={`larp-role ${role === scene.id ? 'is-active' : ''}`}
          aria-pressed={role === scene.id}
          onClick={() => onSelect(scene.id)}
        >
          {scene.label}
        </button>
      ))}
    </div>
  );
};

export default LarpBar;
